import { connect } from 'react-redux';

import { IReduxState, TThunkDispatch } from '../../types/redux';
import { getMeta } from '../../actions/filters';
import { FiltersSearchButtons, IFiltersSearchButtonsProps } from '../../components/FiltersSearchButtons';

type TFiltersStateProps = Pick<IFiltersSearchButtonsProps, 'pageKind' | 'meta' | 'geocode'>;
type TFilterOfferTypeDispatchProps = Pick<IFiltersSearchButtonsProps, 'getMeta'>;

export function mapStateToProps(state: IReduxState): TFiltersStateProps {
  return {
    pageKind: state.page.kind,
    meta: state.filters.meta,
    geocode: state.filters.geocode,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    getMeta: () => dispatch(getMeta()),
  };
}

export const FiltersSearchButtonsContainer = connect(mapStateToProps, mapDispatchToProps)(FiltersSearchButtons);
